"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeDashboardChangeLog", function ($http, $translate) {
  return {
    restrict: "E",
    scope: {
      naturesApplicationCouranteUniquement: '@',
      // true ou false
      horsSubvention: '@' // true ou false
    },
    replace: true,
    template: require("./home-dashboard-changeLog.html"),
    controllerAs: "componentCtrl",
    controller: function controller($scope) {
      var ctrl = this;
      ctrl.filter = {
        saisieConsultants: true,
        saisieClients: true,
        depuis: 30,
        naturesApplicationCouranteUniquement: $scope.naturesApplicationCouranteUniquement,
        horsSubvention: $scope.horsSubvention
      };
      $scope.getRecuperations = function () {
        var params = _.clone(ctrl.filter);
        $scope.loadingChangelog = true;
        $http.get('/rest/home/home-changelog/list', {
          params: params
        }).then(function (response) {
          $scope.modifications = response.data;
        }).finally(function () {
          $scope.loadingChangelog = false;
        });
      };
      var showSectionCookie = "home.show-changeLog";
      $scope.view = {
        showSection: $.cookie(showSectionCookie) !== undefined ? $.cookie(showSectionCookie) === 'true' : true
      };
      $scope.changeShow = function () {
        $scope.view.showSection = !$scope.view.showSection;
        $.cookie(showSectionCookie, $scope.view.showSection);
      };
      $scope.$watch("componentCtrl.filter", function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue) {
          $scope.getRecuperations();
        }
      }, true);
      $scope.getRecuperations();
      $scope.modificationsTableConfig = {
        source: "modifications",
        height: 800,
        allowSelection: true,
        selectionAttribute: "selectedModif",
        selectionScope: $scope,
        columns: [{
          id: 'date',
          attribute: 'date',
          title: 'Date',
          filter: "dateShort",
          sortable: true,
          sortType: "date",
          width: 100,
          cellClass: 'align-c'
        }, {
          attribute: "compteNomInterne",
          title: 'Compte',
          sortable: true,
          width: 300,
          cellClass: 'align-l',
          template: '<span>{{::model.compteNomInterne}}</span>'
        }, {
          title: 'Changement',
          attribute: "descriptions",
          template: "\n                            <div style='max-height: 200px;overflow-y: auto'><div ng-repeat='m in model.compteLogs track by $index'>\n                                <span ng-if=\"m.garantie==true\" class='module-dg mr-xs'>dg</span>\n                                <span ng-if=\"m.pret==true\"  tl-tooltip=\"Pr\xEAt octroy\xE9\" class='module-pret mr-xs'>P</span>\n                                <span> {{m.description}}</span> <span class='b i'>{{m.user}}</span>\n                            </div>\n\n                            <div ng-repeat='m in model.modificationProduits'>\n                            <span class='sim-pill'>{{::m.reference}}</span>\n                            <pill-nature-produit class='ml-xs' ng-if=\"m.nature!='EMPRUNT_BANCAIRE'\" nature='{{::m.nature}}'></pill-nature-produit>\n                            <span ng-if=\"m.garantie==true\" class='module-dg ml-xs' tl-tooltip=\"Dette garantie\">dg</span>\n                            <span ng-if=\"m.pret==true\"  tl-tooltip=\"Pr\xEAt octroy\xE9\" class='module-pret ml-xs'>P</span>\n                             <span ng-if='m.nbMaj>1' class='i'>{{m.nbMaj}} changements.</span>\n                            <div ng-repeat='m in m.modifications track by $index'> <span class=''>- {{m.modification}}</span>\n                                 <span class='ml-xs i b'>({{m.user}})</span>\n                                <i class='ml-xs fa fa-search-plus blue' tl-tooltip ng-if='!view.detail && m.detail && m.detail.length>0'>\n                                    <tl-tooltip-content>\n                                        <div>\n                                            <span ng-bind-html='m.detail' class='changements-produit'></span>\n                                        </div>\n                                    </tl-tooltip-content>\n                                </i>\n                                <div ng-if='view.detail && m.detail && m.detail.length>0'>\n                                    <i class='mr-xs fa fa-search-plus blue'></i>\n                                    <span ng-bind-html='m.detail' class='changements-produit darkBlue'></span>\n                                </div>\n                            </div>\n                            </div>\n"
        }]
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/changelog/home-dashboard-changeLog.js
// module id = 2788
// module chunks = 13